import React, { useEffect } from 'react';
// Context
import { Context as AuthContext } from '../../Redux/context/AuthContext';

// MUI Core & Icons
import styled from '@material-ui/core/styles/styled';
import Tooolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import Badge from '@material-ui/core/Badge';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

import MenuIcon from '@material-ui/icons/Menu';
import ExitToApp from '@material-ui/icons/AccountCircle';
import NotificationIcon from '@material-ui/icons/Notifications';
// import CloseIcon from '@material-ui/icons/CloseOutlined';
import useOutsideClick from '../../utils/hooks/useOutsideClick';
import { AppBar, AnnouncementLabel } from './utils';
import DescriptionIcon from '@material-ui/icons/Description';

// Custom Components
import { Link } from '../SideNav';
import Dialog from '../Dialog';
import { Spacer } from '../Typography';
import colors from '../../theme/colors';
import shadows from '../../theme/shadows';
import { Box } from '../Layouts';
import { dataFormatter } from '../../utils/formatter';
import NotificationCard from '../NotificationCard';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  getNotificationCount,
  getNotifications,
  readAllNotification,
} from '../../Redux/actions/notificationAction';
import { setApobSeller } from '../../Redux/actions/setApobSellerAction';
import { MILISECONDS_IN_MINUTE } from '../../utils/utils';
import TermsAndConditionPage from '../../pages/TermsAndCondition';
import { useState } from 'react';
import Button from '../../components/Button';
import { pilotSellers } from '../../utils/constants';
import { MdOndemandVideo } from 'react-icons/md';
import { moengageTrackEvent } from '../../Analytics/moengageEventFunction';
import SelectList from '../Select/selectList';
import getApobSupplierId from '../../utils/getApobSupplierId';
import { arzoooS3Url, isProd } from '../../utils/checkMode';

export const StyledCard = styled('div')(() => ({
  position: 'fixed',
  right: 24,
  top: 70,
  width: 500,
  boxShadow: shadows.button,
  border: '1px solid' + colors.border,
  background: colors.white,
  maxHeight: '80vh',
  overflowY: 'auto',
  borderRadius: 4,
  padding: 10,
}));

const BoxVideo = styled(Box)(() => ({
  position: 'relative',
  marginRight: '50px',
  marginTop: '10px',
  width: '30px',
  height: '30px',
  cursor: 'pointer',
}));

const ToolTipVideo = styled(AnnouncementLabel)(() => ({
  fontSize: '10px',
  top: '30px',
  height: '20px',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
}));

const IconVideo = styled(MdOndemandVideo)(() => ({
  color: 'grey',
}));

const AppIcon = styled('img')(() => ({
  height: '43px',
  cursor: 'pointer',
  marginRight: '20px',
}));

const Toolbar = ({ toggleNav, open }) => {
  const { logout } = React.useContext(AuthContext);
  const userData = JSON.parse(localStorage.getItem('login_data'));
  const [openMenu, setMenuOpen] = React.useState(false);
  const [isNotifcnOpen, toggleNotification] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [agreementOpen, setAgreementOpen] = useState(false);
  const anchorRef = React.useRef(null);
  const ref = React.useRef(null);
  const dispatch = useDispatch();
  const [sellerList, setSellerList] = useState([]);
  const [showApobList, setShowApobList] = useState(false);

  const setSelectedSeller = (supplierDetails) => {
    if (supplierDetails?.apobSupplierID) {
      dispatch(setApobSeller(supplierDetails));
    }
  };

  const { count, list } = useSelector((state) => state.notification);
  const { apobSellerList } = useSelector((state) => {
    return state.apobSeller;
  });
  const { apobSupplierID } = getApobSupplierId();
  useEffect(() => {
    if (apobSellerList) {
      setSellerList(apobSellerList.apobSellerList);
      if (userData.user_id) {
        setSelectedSeller({
          apobSupplierID: userData.user_id,
          isClearTaxInvoice: userData.isClearTaxInvoice,
          isIrnNeeded: userData.isIrnNeeded,
        });
      }
      if (apobSellerList?.apobSellerList && apobSellerList.apobSellerList.length > 1) {
        setShowApobList(true);
      }
    }
  }, [apobSellerList]);

  const endSession = async () => {
    await logout();
  };

  const handleDialogAction = (flag) => {
    if (flag) endSession();
    setDialogOpen(false);
  };

  const referNow = () => {
    let url = isProd
      ? 'https://referals.arzoopro.com/referal?from=website&user=na'
      : 'https://referals.dev.arzoopro.com/referal?from=website&user=na';
    window.open(url, '_blank');
  };

  const handleOpenPdf = () => {
    let url = arzoooS3Url + '/falcon-nic-doc/GST+API+Credentials+Process+Flow.pdf';
    window.open(url, '_blank');
  };

  const getNotifcnCount = () => {
    // TODO: unComment dispatch method to enable the notitification feature
    dispatch(getNotificationCount(apobSupplierID));
  };

  // Call Notification count API when page is rerendered
  React.useEffect(() => getNotifcnCount(), []);
  // Call Notification count API in every 20 - 30 min
  let MS_IN_5_MIN = MILISECONDS_IN_MINUTE * 5;
  React.useEffect(() => {
    let timer = setInterval(() => {
      getNotifcnCount();
    }, MS_IN_5_MIN);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const fetchNotifications = () => dispatch(getNotifications(apobSupplierID));

  const readAll = () => {
    dispatch(readAllNotification(apobSupplierID));
    toggleNotification(false);
  };

  useOutsideClick(ref, () => {
    if (isNotifcnOpen) {
      toggleNotification(false);
    }
  });

  const handleChangeSeller = (item) => {
    setSelectedSeller(item);
    // dispatch(setApobSeller(item.value));
  };

  return (
    <AppBar position="fixed" open={open}>
      <Tooolbar>
        <IconButton color="inherit" aria-label="open drawer" onClick={toggleNav} edge="start">
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap>
          {showApobList ? (
            <SelectList
              list={sellerList.map((item) => {
                return {
                  label: item.name,
                  apobSupplierID: item.supplierId,
                  isClearTaxInvoice: item.isClearTaxInvoice,
                  isIrnNeeded: item.isIrnNeeded,
                };
              })}
              selected={apobSupplierID}
              onChange={handleChangeSeller}
            />
          ) : (
            userData?.name && userData?.name.toUpperCase()
          )}
        </Typography>
        <Spacer />
        <AppIcon
          src="/images/download-now2.gif"
          onClick={() => {
            window.open('https://play.google.com/store/apps/details?id=com.arzooofalcon');
          }}
        />
        {/* {pilotSellers.includes(userData['phone_number']) && ( */}
        {/* <BoxVideo
          onClick={() => {
            window.open('https://youtu.be/O9cqlfhMxuk');
          }}
          moenagage-id={JSON.stringify({
            eventName: 'Seller_learning_platform',
            eventDetails: 'clicked on Video tutorial',
          })}
        >
          <ToolTipVideo>
            <span>Click here to view on how to create API Credentials</span>
          </ToolTipVideo>

          <div className="video_logo">
            <IconVideo size={30} />
            <div className="circle">
              <div className="new">NEW</div>
            </div>
          </div>
        </BoxVideo> */}
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.open('https://einvoice1.gst.gov.in')}
            moenagage-id={JSON.stringify({
              eventName: 'Seller_learning_platform',
              eventDetails: 'clicked on Create your e-invoice button',
            })}
          >
            Auto Invoice
          </Button>
          <Tooltip title="Click here to know how to generate e-Invoice API credentails">
            <IconButton
              onClick={handleOpenPdf}
              moenagage-id={JSON.stringify({
                eventName: 'Seller_learning_platform',
                eventDetails: 'clicked on Pdf tutorial',
              })}
            >
              <DescriptionIcon style={{ color: 'gray', width: 30, height: 30 }} />
            </IconButton>
          </Tooltip>
        </Box>
        {/* )} */}
        <Box ref={ref} style={{ paddingRight: '10px' }}>
          <IconButton
            onClick={() => {
              toggleNotification(!isNotifcnOpen);
              fetchNotifications();
            }}
          >
            <Badge
              badgeContent={count}
              color="primary"
              moenagage-id={JSON.stringify({
                eventName: 'Home_page_notifications_clicked',
                eventDetails: 'Notification clicked and viewed',
              })}
            >
              <NotificationIcon />
            </Badge>
          </IconButton>
        </Box>
        <Box onClick={referNow} style={{ paddingRight: '5px' }}>
          <AnnouncementLabel style={{ fontSize: '10px' }}>
            Win upto {dataFormatter(25000, 'currency')}
          </AnnouncementLabel>
          <IconButton>
            <span className="arz-announcement" style={{ fontSize: 'inherit' }} />
          </IconButton>
        </Box>
        {/* Logout Icon */}
        <Tooltip title="Logout" arrow>
          <IconButton
            variant={'outlined'}
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={() => setMenuOpen((prevOpen) => !prevOpen)}
          >
            {/* <span className="arz-user" /> */}
            <ExitToApp fontSize="inherit" />
          </IconButton>
        </Tooltip>
        {/* Menu Items section */}
        <Popper
          open={openMenu}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                width: '10rem',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
                  <MenuList autoFocusItem={open} id="menu-list-grow">
                    <MenuItem onClick={() => setMenuOpen(false)}>
                      <Link
                        to={{
                          pathname: '/vendor-details',
                          state: { source: 'from profile section on header' },
                        }}
                      >
                        Profile
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setAgreementOpen(true);
                        setMenuOpen(false);
                        moengageTrackEvent('Seller_agreement_viewed', {});
                      }}
                    >
                      <span>Seller Agreement</span>
                    </MenuItem>
                    <MenuItem onClick={() => setDialogOpen(true)}>Logout</MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
        {/* end of Menu Items section */}

        {/* Confirmation Box */}
        {dialogOpen ? <Dialog open={dialogOpen} onAction={handleDialogAction} /> : null}
        {/* End of Confirmation Box */}
        {agreementOpen && (
          <TermsAndConditionPage
            agreementOpen={agreementOpen}
            closeAgreementOpen={setAgreementOpen}
            showTerms={true}
            showWorkingHours={true}
            disableButtons={true}
            showClose={true}
          />
        )}
        {/* Notification section */}
        {isNotifcnOpen && (
          <StyledCard onClick={(e) => e.stopPropagation()} style={{ width: '25rem' }}>
            <NotificationCard notifications={list} onReadAll={readAll} />
          </StyledCard>
        )}
        {/* End Notification section */}
      </Tooolbar>
    </AppBar>
  );
};

export default React.memo(Toolbar);
